import { AssetType } from 'core/logic/asset/asset.types'
import { UserAddress } from 'core/modules/firebase/service/user'
import { PropsWithChildren } from 'react'

export type DigitalTwinProps = {
  asset: AssetType
  onSubmit: ({}: {
    photos: string[]
    price: number
    description: string
    address: UserAddress
    paymentData: string
  }) => void
}
export type DigitalTwinViewProps = PropsWithChildren<DigitalTwinProps> & {
  currentStep: any
}
export type Continuable = {
  onContinue: () => void | Promise<void>
  canContinue: boolean
  continueLabel?: string
}

export enum DigitalTwinSteps {
  PHOTOS,
  DESCRIPTION,
  PRICE,
  PAYMENT_METHOD,
  ORIGIN_ADDRESS,
  RESUME
}

export type LocalReferenceableUpload = {
  task: FBUploadTask | FBReference
  objUrl: string
  file?: File
}

export type DraftShape = Partial<{
  description: string
  price: string
  paymentData: string
  originAddress: UserAddress['id']
}>

export type DraftBound = {
  draft?: DraftShape
}
